/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useOrganizationsPageStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '720px',
  },
  noItemsLabel: {
    margin: '20px 0',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
    gridAutoRows: 'minmax(100px, 1fr) repeat(minmax(100px, 1fr), 1px)',
    alignItems: 'center',
  },
  divider: {
    gridColumn: '1 / -1',
  },
  cell: {
    height: '100%',
    alignContent: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
}));
